import React, { Component } from 'react';
import PropTypes from 'prop-types';

import axios from '../../../axios/axios';
import NewsSectionItem from '../../components/main/NewsSectionItem';
import { NavLink } from 'react-router-dom';
import Loader from '../../components/loader/loader';
import { translateStaticContent } from '../../../helpers/translateStaticContent';

class NewsSection extends Component {
    constructor(props) {
        super(props);
        this.state = {
            news: [],
            loading: false
        }
    }

    componentDidMount() {
        this.getNews();
    }

    componentDidUpdate(prevProps) {
        if (this.props.activeLang !== prevProps.activeLang) {
            this.getNews();
        }
      }

    getNews = () => {
        this.setState({...this.state, loading: true }, () => {
            axios.defaults.headers.isocode = this.props.activeLang ? this.props.activeLang : 'uk';
            axios.get(`api/welsend/public/news/langDetailAndFileMetadata?page=0&size=4`)
            .then(res => res.data)
            .then(news => {
                this.setState({...this.state, news: news.newsDtos, loading: false})
            })
            .catch((error =>  {
                console.log(error);
            }))
        })
    }

    newsList = () => {
        if (this.state.news.length > 0) {
            const news =  this.state.news.map(item => {
              return <NewsSectionItem  news={item} 
                                key={item.newsId} 
                      />})
            return news;
          }  else return null;
    }

    render() {
        return (
            <div className='container-wrapper'>
                <div className="container news-section">
                    <h2>
                        {translateStaticContent('newsHeading', 
                             this.props.defaultStaticContentNews, this.props.activeLangStaticContentNews)}
                    </h2>
                    {this.state.loading ? <Loader /> :
                        <div className='page'>
                            {this.newsList()}
                        </div>
                    }
                    <NavLink to='/news' className='more-news' rel="noreferrer">
                        {translateStaticContent('moreNewsBtn', 
                             this.props.defaultStaticContentNews, this.props.activeLangStaticContentNews)}
                    </NavLink>
                </div>
            </div>
        )
    }
}

export default NewsSection;

NewsSection.propTypes = {
    activeLang: PropTypes.string.isRequired,
    defaultStaticContentNews: PropTypes.object,
    activeLangStaticContentNews: PropTypes.object,
}
